import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { localeEs } from "./shared/utils/primeng-locale";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(private messageService: MessageService) {}

  ngOnInit() {
    // this.configPrime.setTranslation(localeEs);
  }

  title = 'butaco-clientes';
}
